import { render, staticRenderFns } from "./OBooleanSelect.vue?vue&type=template&id=660dd340&scoped=true&"
import script from "./OBooleanSelect.vue?vue&type=script&lang=js&"
export * from "./OBooleanSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660dd340",
  null
  
)

export default component.exports